import { Component, Input } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';

import { TimerWidgetContent } from './timer-widget-wrapper.model';
import { TimerWidgetComponent } from '../timer-widget.component';

@Component({
  selector: 'wl-timer-widget-wrapper',
  templateUrl: './timer-widget-wrapper.component.html',
  standalone: true,
  imports: [TimerWidgetComponent],
})
export class TimerWidgetWrapperComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input({ required: true }) set rendering(value: ComponentRendering) {
    this.content = new TimerWidgetContent(value);
  }

  content!: TimerWidgetContent;
}
